import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Settings = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Settings;
